import React from "react";
import { spinner } from "../assets";

type Props = {
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
};
export default function IconPrimary({
  disabled,
  loading,
  onClick,
  children,
}: Props) {
  return (
    // Without an explicit type a <button> defaults to "submit", so these icons
    // submitted whatever <form> they sat in — clicking the pencil on a question
    // fired an exam update (and reloaded the record over the edit in progress).
    <button
      type="button"
      disabled={loading || disabled}
      className="icon_primary"
      onClick={onClick}
    >
      {loading ? (
        <img src={spinner} alt="exam-delete" className="spinner_img_sm" />
      ) : (
        children
      )}
    </button>
  );
}
